import type { FeaturedPostsSection } from "@/data/types";
import featuredPostsData from "@/data/featuredPosts.json";

export function useFeaturedPostsData() {
  return {
    featuredPostsData: featuredPostsData as FeaturedPostsSection
  };
}